import { useFormContext } from 'react-hook-form';
import { HookToggle } from '@/components/UI/HookForm/Form/Toggle';

export function SelectAll({ activeNavItem }: { activeNavItem: string }) {
  const { setValue, getValues } = useFormContext();

  const onSelectAll = (checked: boolean, type: 'EMAIL' | 'IN_APP') => {
    const allNotifications = getValues();
    const currentTabNotifications = allNotifications[activeNavItem];

    Object.keys(currentTabNotifications).forEach((notificationGroup) => {
      if (notificationGroup === 'all') return;

      Object.keys(currentTabNotifications[notificationGroup]).forEach((notification) => {
        setValue(`${activeNavItem}.${notificationGroup}.${notification}.${type}`, checked, {
          shouldDirty: true,
          shouldTouch: true,
        });
      });
    });
  };

  return (
    <div className='flex items-center gap-2 border-b-2 border-gray-200 py-5'>
      <div className='text-lg font-bold'>Select All</div>
      <div className='grow'></div>
      <HookToggle name={`${activeNavItem}.all.EMAIL`} label='Email' onValueChange={(newValue) => onSelectAll(newValue, 'EMAIL')} />
      <HookToggle name={`${activeNavItem}.all.IN_APP`} label='In Index' onValueChange={(newValue) => onSelectAll(newValue, 'IN_APP')} />
    </div>
  );
}
